/*
    © 2023 EcomGraduates.com
    https://www.ecomgraduates.com
*/

// Navbar megamenu - Open/close overlay
document.querySelectorAll('#navbar-desktop .dropdown-toggle').forEach(dropdown => {
  const init = () => {
    if (document.querySelector('#navbar-desktop .dropdown-menu.show')) {
      document.querySelector('#main').classList.add('main-hidden')
    } else {
      document.querySelector('#main').classList.remove('main-hidden')
    }
  }
  dropdown.addEventListener('shown.bs.dropdown', init)
  dropdown.addEventListener('hidden.bs.dropdown', init)
})

// Navbar megamenu - Hover trigger mode for parent menu items
document.querySelectorAll('#navbar-desktop.menu-desktop-hover .nav-item.dropdown').forEach(dropdown => {
  const bsDropdown = bootstrap.Dropdown.getOrCreateInstance(dropdown.querySelector('.nav-link'))

  dropdown.addEventListener('mouseover', () => {
    document.querySelectorAll('#navbar-desktop.menu-desktop-hover .dropdown-menu').forEach(menu => {
      if (menu.previousElementSibling.dataset.index !== dropdown.querySelector('.nav-link').dataset.index) {
        menu.classList.remove('show')
      }
    })
    bsDropdown.show()
  })

  dropdown.addEventListener('mouseleave', () => {
    setTimeout(() => {
      if (!dropdown.matches(':hover')) {
        bsDropdown.hide()
      }
    }, 200)
  })
})

// Navbar transparent header
const fixNavbarTransparentHeader = () => {
  document.querySelectorAll('.navbar.navbar-transparent').forEach(navbar => {
    const hasTextBody = navbar.classList.contains('text-body')

    if (navbar && hasTextBody) {
      window.addEventListener('scroll', (event) => {
        if (window.scrollY > 0) {
          navbar.classList.add('text-body')
          navbar.classList.remove('text-white')
        } else {
          navbar.classList.remove('text-body')
          navbar.classList.add('text-white')
        }
      })
    }
  })
}
fixNavbarTransparentHeader()

/*
Footer - Scroll top button
*/
const initFooterScrollTop = () => {
  const btn = document.querySelector('#footer-scroll-top')

  if (!btn) return

  document.addEventListener('scroll', window.throttle(() => {
    if (window.scrollY > Number(btn.dataset.scroll)) {
      btn.classList.add('btn-show')
    } else {
      btn.classList.remove('btn-show')
    }
  }, 200))
}
initFooterScrollTop()

// Quantity steppers (plus/minus)
window.onClickQtyPlusMinus = (btn) => {
  const input = btn.closest('.quantity-wrapper').querySelector('input')
  const inputValue = Number(input.value)

  if (btn.dataset.mode === 'plus') {
    input.value = inputValue + 1
  } else {
    if (input.value > Number(input.dataset.minQty)) {
      input.value = inputValue - 1
    }
  }

  const event = new Event('change')
  input.dispatchEvent(event)
}

// Share links using WebShare API
window.onLinkShare = (btn, e) => {
  if (navigator.share) {
    navigator.share({
      title: btn.dataset.shareTitle,
      url: window.location.href
    })
  } else {
    const popover = bootstrap.Popover.getOrCreateInstance(btn, {
      content: `
                <div class="input-group input-group-sm">
                    <input type="text" class="form-control" value="${window.location.href}">
                    <button id="btn-share-copy" class="btn btn-outline-secondary" type="button">${btn.dataset.textCopy}</button>
                </div>
            `,
      html: true,
      sanitize: false,
      placement: 'top'
    })

    popover.show()

    document.querySelector('#btn-share-copy')?.addEventListener('click', (e) => {
      navigator.clipboard.writeText(window.location.href)
      e.target.textContent = btn.dataset.textCopied
    })

    setTimeout(() => {
      popover.hide()
      btn.blur()
    }, 4000)
  }
}

// Search page - set selected value for the types select field
const initSearchPageSetSelected = () => {
  const select = document.querySelector('#search-header .form-select')

  if (!select) return

  const params = new URLSearchParams(location.search)
  const type = params.get('type')

  if (!type) return

  select.value = type
}
initSearchPageSetSelected()

// Countdown timers
const initCountdownTimers = () => {
  document.querySelectorAll('.countdown-timer').forEach((elem) => {
    if (elem.classList.contains('init')) return

    elem.classList.add('init')

    let end = Number(elem.dataset.time) * 1000

    if (window.location.href.includes('ecomifytheme')) {
      end = Date.now() + 1.08e+7
    }

    const seconds = 1000
    const minutes = seconds * 60
    const hours = minutes * 60
    const days = hours * 24
    const daysElem = elem.querySelector('[data-days]')

    const x = setInterval(() => {
      const now = new Date().getTime()
      const difference = end - now

      if (difference < 0) {
        clearInterval(x)
        elem.remove()
        return
      }

      elem.removeAttribute('hidden')

      // Timers with a [data-days] element show days, and hours become the remainder
      const d = daysElem ? Math.floor(difference / days) : 0
      const h = Math.floor((daysElem ? difference % days : difference) / hours)
      const m = Math.floor((difference % hours) / minutes)
      const s = Math.floor((difference % minutes) / seconds)

      elem.querySelector('[data-hours').innerText = `${h}${elem.dataset.textH}`
      elem.querySelector('[data-hours').setAttribute('aria-label', `${h} ${elem.dataset.textHours}`)
      elem.querySelector('[data-minutes').innerText = `${m}${elem.dataset.textM}`
      elem.querySelector('[data-minutes').setAttribute('aria-label', `${m} ${elem.dataset.textMinutes}`)
      elem.querySelector('[data-seconds').innerText = `${s}${elem.dataset.textS}`
      elem.querySelector('[data-seconds').setAttribute('aria-label', `${s} ${elem.dataset.textSeconds}`)

      if (daysElem) {
        daysElem.innerText = `${d}${elem.dataset.textD}`
        daysElem.setAttribute('aria-label', `${d} ${elem.dataset.textDays}`)
        daysElem.toggleAttribute('hidden', d === 0)
      }

      if (h === 0 && d === 0) {
        elem.querySelector('[data-hours').setAttribute('hidden', 'hidden')
      }
    }, seconds)
  })
}
initCountdownTimers()

document.addEventListener('shopify:section:load', (e) => {
  if (e.target.querySelector('.countdown-timer')) {
    initCountdownTimers()
  }
})

// Shopify Official Reviews app
// https://apps.shopify.com/product-reviews
const initSprBadges = () => {
  window.SPR?.initDomEls()
  window.SPR?.loadBadges()
}
window.addEventListener('updated.ecomify.cart', initSprBadges)
window.addEventListener('updated.ecomify.collection', initSprBadges)

if (document.querySelector('#shopify-product-reviews')) {
  setInterval(() => {
    document.querySelector('.spr-summary-actions-newreview')
      .classList.add('btn', 'btn-secondary')

    document.querySelectorAll('input.spr-form-input').forEach(input => {
      input.classList.add('form-control')
    })

    document.querySelectorAll('textarea.spr-form-input').forEach(textarea => {
      textarea.classList.add('form-control')
    })
  }, 2000)
}

// Rivyo Reviews app styling
const initRivyoReviews = () => {
  const wrapper = document.querySelector('.tydal-reviews-iframe-panel-wrapper')

  if (!wrapper) return

  wrapper.classList.add('container')
}
initRivyoReviews()

// Small fix for the demo megamenu/mobile-menu
// remove active classes
if (window.location.href.includes('ecomify')) {
  document.querySelectorAll('.dropdown-megamenu .dropdown-item.active').forEach(item => {
    item.classList.remove('active')
  })
  document.querySelectorAll('#offcanvas-menu .dropdown-item.active').forEach(item => {
    item.classList.remove('active')
  })
}

/*
    Prev/Next Articles in the Article view page
*/
const initPrevNextArticleButtons = async () => {
  const wrapper = document.querySelector('#article-prev-next')

  if (!wrapper) return

  await new Promise(resolve => setTimeout(resolve, 1000))

  const threshold = 600

  window.addEventListener('scroll', () => {
    if (window.scrollY > threshold) {
      wrapper.classList.add('show')
    } else {
      wrapper.classList.remove('show')
    }
  })
}
initPrevNextArticleButtons()

// Inactive tab title
const initInactiveTabTitle = () => {
  const text = document.documentElement.dataset.inactiveTabText

  if (!text) return

  const originalTitle = document.title
  let index = 0
  let myInterval

  function setPageTitle() {
    index = ++index
    const newtitle = (index === 0) ? '' : text.slice(0, index)
    document.title = newtitle

    if (index === text.length) {
      index = 0
    }
  }

  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'hidden') {
      myInterval = setInterval(setPageTitle, 50)
    } else {
      clearInterval(myInterval)
      index = 0
      document.title = originalTitle
    }
  })
}
initInactiveTabTitle()

// wrap apps in a container
document.querySelectorAll('.shopify-section > .shopify-app-block').forEach(elem => {
  elem.classList.add('container')
})

// Shopify Subscriptions App
document.querySelectorAll('.shopify_subscriptions_fieldset input[type="radio"]').forEach(input => {
  input.classList.add('form-check-input')
})

//scroll progress bar
const scrollProgressBar = document.getElementById("scroll-progress-bar")
if (scrollProgressBar) {
  function progressBarScroll() {
    let winScroll = document.body.scrollTop || document.documentElement.scrollTop,
      height = document.documentElement.scrollHeight - document.documentElement.clientHeight,
      scrolled = (winScroll / height) * 100;
    scrollProgressBar.style.width = scrolled + "%";
  }

  window.onscroll = function () {
    progressBarScroll();
  };
}

// Localization form
document.querySelectorAll('.shopify-localization-form button').forEach(btn => {
  btn.addEventListener('click', () => {
    btn.closest('form').querySelector('[name="country_code"]').value = btn.dataset.isoCode
    btn.closest('form').submit()
  })
})
